"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var rc_motion_1 = tslib_1.__importDefault(require("rc-motion"));
var NormalLoading_1 = require("../Icons/NormalLoading");
var getCollapsedWidth = function () { return ({
    width: 0,
    opacity: 0,
    transform: 'scale(0)',
}); };
var getRealWidth = function (node) { return ({
    width: node.scrollWidth,
    opacity: 1,
    transform: 'scale(1)',
}); };
var LoadingIcon = function (_a) {
    var prefixCls = _a.prefixCls, loading = _a.loading, existIcon = _a.existIcon;
    var visible = !!loading;
    if (existIcon) {
        return (react_1.default.createElement("span", { className: "".concat(prefixCls, "-loading-icon") },
            react_1.default.createElement(NormalLoading_1.NormalLoading, null)));
    }
    return (react_1.default.createElement(rc_motion_1.default, { visible: visible, 
        // We do not really use this motionName
        motionName: "".concat(prefixCls, "-loading-icon-motion"), removeOnLeave: true, onAppearStart: getCollapsedWidth, onAppearActive: getRealWidth, onEnterStart: getCollapsedWidth, onEnterActive: getRealWidth, onLeaveStart: getRealWidth, onLeaveActive: getCollapsedWidth }, function (_a, ref) {
        var className = _a.className, style = _a.style;
        return (react_1.default.createElement("span", { className: "".concat(prefixCls, "-loading-icon"), style: style, ref: ref },
            react_1.default.createElement(NormalLoading_1.NormalLoading, { className: className })));
    }));
};
exports.default = LoadingIcon;
//# sourceMappingURL=LoadingIcon.js.map